<template>
  <footer class="footer">
    <div class="footer-top">
      <div class="container px-5">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-5 text-center">
                <div class="footer-bottom-logo">
                  <router-link to="/" class="menu-logo">
                    <img
                      src="@/assets/talento_agv/img/home/Logo-agv-color.svg"
                      class="img-fluid"
                      style="width: 100px"
                      alt="Logo"
                    />
                  </router-link>
                  <p style="margin-top: -10px">
                    Av. Felipe Pardo y Aliaga 652. Int. 1201 <br />
                    San Isidro, Lima
                  </p>
                  <ul
                    class="redes_sociales_footer"
                    style="margin-top: -10px; justify-content: center"
                  >
                    <li>
                      <a
                        href="https://www.facebook.com/TrabajaEnAgrovisionPeru"
                        target="_blank"
                        ><i
                          class="fa-brands fa-facebook-f"
                          aria-hidden="true"
                        ></i
                      ></a>
                    </li>
                    <li>
                      <a
                        href="https://www.tiktok.com/@agrovision.peru"
                        target="_blank"
                        ><i class="fa-brands fa-tiktok" aria-hidden="true"></i
                      ></a>
                    </li>
                    <!-- <li>
                      <a
                        href="https://www.instagram.com/agrovisionperu/;"
                        target="_blank"
                        ><i
                          class="fa-brands fa-instagram"
                          aria-hidden="true"
                        ></i
                      ></a>
                    </li> -->
                    <li>
                      <a
                        href="https://www.linkedin.com/company/agrovisionperu/mycompany/"
                        target="_blank"
                        ><i class="fa-brands fa-linkedin" aria-hidden="true"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-4">
                <div class="footer-widget footer-menu">
                  <h2 class="footer-title">Enlaces</h2>
                  <ul>
                    <li>
                      <router-link to="/"
                        ><i class="fas fa-angle-right me-1"></i
                        >Inicio</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/nuestra_cultura"
                        ><i class="fas fa-angle-right me-1"></i>Nuestra
                        Cultura</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/young_talent"
                        ><i class="fas fa-angle-right me-1"></i>Programa Young
                        Talent</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/escuela_corporativa"
                        ><i class="fas fa-angle-right me-1"></i>Escuela
                        Corporativa</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-3">
                <div class="footer-widget footer-menu">
                  <h2 class="footer-title">Acceso al Sistema</h2>
                  <ul>
                    <!-- <li>
                      <router-link to="/crear_cuenta"
                        ><i class="fas fa-angle-right me-1"></i>Crear
                        Cuenta</router-link
                      >
                    </li> -->
                    <li>
                      <router-link to="/login"
                        ><i class="fas fa-angle-right me-1"></i
                        >Ingresar</router-link
                      >
                    </li>
                    <li class="pt-3">
                      <img
                        src="@/assets/talento_agv/img/home/Certificado-Sep-2024-2025.png"
                        class="img-fluid"
                        style="width:90px; height: 90px;"
                        alt="Logo"
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container px-5">
        <div class="copyright">
          <div class="row">
            <div class="col-md-12">
              <div class="copyright-text text-center">
                <p class="mb-0">
                  Copyright {{ new Date().getFullYear() }} &copy; Agrovision.
                  Todos los derechos reservados.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style>
  @media (max-width: 768px) {
    .redes_sociales_footer {
      justify-content: start !important;
    }
  }
</style>
